import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

//const pm2 = require('pm2')

class RestartApp extends Component {

  constructor(props) {
      super(props);
    
  }

  componentDidMount() {
      
  }

  componentWillUnmount() {
    
  }

  restartapp(){

    //pm2.restart(1);
    alert("Restarted");

  }

  render() {

     
    return (

        <React.Fragment>
        <AdminLayout>

           <button onClick={this.restartapp} >Restart now</button>
               
        </AdminLayout>
    </React.Fragment>

      
    );
  }
}

export default RestartApp;


// WEBPACK FOOTER //
// ./src/components/bewise/restart.jsx